import Image from 'next/image';
import s from './InterestPoint.module.css';
import { InterestPointProps } from '@/types/model';
import { ImageLoader } from '@/lib/imageLoader';
import { motion } from 'framer-motion';

const InterestPoint = ({ image, items, title }: InterestPointProps) => {
  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}>
      <div className={s.container__image}>
        <Image
          src={ImageLoader({ src: image?.url })}
          fill
          sizes="(min-width: 62em) 100vw, 750px"
          quality={65}
          alt="map"
        />
      </div>
      <div className={s.container__info}>
        <h4 className={s.container__info__title}>{title}</h4>
        <ul className={s.container__info__list}>
          {items.map((item) => (
            <li key={item.label}>{item.label}</li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};

export default InterestPoint;
